import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { useAddFolderModal } from '../context/AddFolderModalContext';

const FolderPathLabel: FC = () => {
  const { t } = useTranslate();

  const { data } = useAddFolderModal();

  const ancestors = data.currentFolder?.ancestors || [];
  const folderName = data.currentFolder?.name || '';

  return (
    <div className="folder-path-label">
      <span className="folder-path-label__segment">{t('MyFolders')}</span>
      {ancestors.map((a) => (
        <span key={a._id} className="folder-path-label__segment">
          <span className="folder-path-label__separator">/</span>
          {a.name}
        </span>
      ))}
      {folderName && (
        <span className="folder-path-label__segment">
          <span className="folder-path-label__separator">/</span>
          {folderName}
        </span>
      )}
    </div>
  );
};

export default FolderPathLabel;
